import { KYMW0E00Component } from './kymw0e00.component';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';

/**
 * 使用ページ確認画面の値を管理するクラス
 *
 * @export KYMW0E00Model
 * @class KYMW0E00Model
 */
export class KYMW0E00Model {

  kymw0E00Component: KYMW0E00Component;

  public imageId: string = <string>'';
  public imageName: string = <string>'';
  public imageFileName: string = <string>'';
  public startOrderCodeBefore: string = <string>'';
  public endOrderCodeBefore: string = <string>'';
  public startOrderCodeAfter: string = <string>'';
  public endOrderCodeAfter: string = <string>'';
  public usePageList: Array<any> = new Array<any>();		// 使用ページデータ
  public processDiv: number = <number>0;							// 処理区分(1:使用範囲変更時,2:使用停止時,3:削除時)
  public windowVisible: boolean = <boolean>false;				// 使用ページ確認画面の表示状態
  public btnEnabled: boolean = <boolean>false;					// 変更確認ボタンの活性状態
  public orderCodeVisible: boolean = <boolean>false;			// 使用範囲の表示状態
  public colorList: Array<any> = new Array<any>();
  // 念校戻し以前のフェーズ：ピンク
  public very_final_proof  : string = getComputedStyle(document.documentElement).getPropertyValue('--very-final-proof');
  // 通常データ：白
  public not_very_final_proof: string = getComputedStyle(document.documentElement).getPropertyValue('--not-very-final-proof');

  /**
   * 使用ページ確認の初期データ取得
   * @param data:サーバから取得されたXMLデータ
   */
  public getUsePage(serverData: any): void {

    // 使用ページが０件の場合
    if (serverData === null || PlessViewUtilsSub.isEmptyArray(serverData)) {
      // 呼出元画面に「1:変更OK」を通知し、以降の処理は行わない
      this.kymw0E00Component.exitKYMW0E00(1);
      return;
    }

    const dataList: Array<any> = serverData;

    // 使用ページが０件の場合
    if (PlessViewUtilsSub.isEmptyArray(dataList)) {
      // 呼出元画面に「1:変更OK」を通知し、以降の処理は行わない
      this.kymw0E00Component.exitKYMW0E00(1);
      return;
    }

    // 画面を表示する
    this.windowVisible = true;

    // 取得データを表示
    this.usePageList = dataList;

    // 背景色を設定
    this.setColorPattern();

    // 1:使用範囲変更時
    if (this.processDiv === 1) {
      // 使用範囲変更不可メッセージを表示
      this.kymw0E00Component.dialogService.openAlertGetMessage('E0199', null,
        () => {
          setTimeout(() => {
            this.kymw0E00Component.btn_Close.nativeElement.focus();
          });
        });
      this.btnEnabled = false;
      this.orderCodeVisible = true;
    } else if (this.processDiv === 2) {
      // 2:使用停止時
      // 念校戻し以前のフェーズが存在する場合
      if (this.isFinalProofsStatus()) {
        // 使用停止不可メッセージを表示
        this.kymw0E00Component.dialogService.openAlertGetMessage('E0214', null,
          () => {
            setTimeout(() => {
              this.kymw0E00Component.btn_Close.nativeElement.focus();
            });
          });
        this.btnEnabled = false;
      } else {
        this.btnEnabled = true;
        setTimeout(() => {
          this.kymw0E00Component.btn_Close.nativeElement.focus();
        });
      }

      this.orderCodeVisible = false;
    } else if (this.processDiv === 3) {
      // 3:削除時
      // 削除不可メッセージを表示
      this.kymw0E00Component.dialogService.openAlertGetMessage('E0200', null,
        () => {
          setTimeout(() => {
            this.kymw0E00Component.btn_Close.nativeElement.focus();
          });
        });
      this.btnEnabled = false;
      this.orderCodeVisible = false;
    }
  }

  /**
   * 「企画確定」以前の工程有無の確認
   *  存在する場合にtrueを返す
   */
  private isFinalProofsStatus(): boolean {
    let flg: boolean = <boolean>false;
    for (let i = Number(0); i < this.usePageList.length; i++) {
      if (this.usePageList[i].FinalProofsStatus === '1') {
        flg = true;
        break;
      }
    }
    return flg;
  }

  /**
   * 一覧の背景色を設定
   */
  private setColorPattern(): void {
    const colorAry: Array<any> = new Array<any>();
    for (let i = Number(0); i < this.usePageList.length; i++) {
      if (this.usePageList[i].FinalProofsStatus === '1') {
        // 念校戻し以前のフェーズ：ピンク
        colorAry.push(this.very_final_proof);
      } else {
        // 通常データ：白
        colorAry.push(this.not_very_final_proof);
      }
    }

    // デフォルト表示行数(7行)以下の場合は残りの背景色を白にする
    if (this.usePageList.length < 7) {
      for (let j = Number(0); j < 7 - this.usePageList.length; j++) {
        // 通常データ：白
        colorAry.push(this.not_very_final_proof);
      }
    }
    this.colorList = colorAry;
  }
}
